import styled from '@emotion/styled';
import React from 'react';

const StyledWrapper = styled.div({
  display: 'flex',
  flexDirection: 'row-reverse',
  position: 'absolute',
  zIndex: 10,
  top: 16,
  right: 15
});

export default React.memo(StyledWrapper);
